import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import SubjectTeacherService from "../../services/subjectteacher.service";

export const getSubjectTeacher = createAsyncThunk(
    "subjectTeacher/subjectTeacher",
    async (item, thunkAPI) => {
        console.log("Thunk received:", item);

        try {
            const response = await SubjectTeacherService.getsubjectteacher(item);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


export const addSubjectTeacher = createAsyncThunk(
    "subjectTeacher/addsubjectTeacher",
    async (data, thunkAPI) => {
        try {
            const response = await SubjectTeacherService.addsubjectteacher(data);
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


// export const updateClassteacher = createAsyncThunk(
//   "classteacher/updateClassteacher",
//   async (payload, thunkAPI) => {
//     try {
//       const response = await ClassTeacherService.editclassteacher(payload);
//       return response.data;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(
//         error.response?.data?.message || error.message
//       );
//     }
//   }
// );

export const deletesubjectTeacher = createAsyncThunk(
    "subjectTeacher/deletesubjectTeacher",
    async (id, thunkAPI) => {
        try {
            const response = await SubjectTeacherService.deletesubjectteacher(id);
            return id;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || error.message
            );
        }
    }
);


const initialState = {
    loading: false,
    error: null,
    subjectTeacher: [],
    totalDataCount:"",
};


const SubjectTeacherSlice = createSlice({
    name: "subjectteacher",
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(getSubjectTeacher.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(getSubjectTeacher.fulfilled, (state, action) => {
                state.loading = false;
                state.subjectTeacher = action.payload?.data || [];
                state.totalDataCount =action.payload?.totalDataCount || "";
            })


            .addCase(getSubjectTeacher.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default SubjectTeacherSlice.reducer;
